import { useState } from 'react';
import { DetailHero } from '../components/DetailHero';
import { DetourPill } from '../components/DetourPill';
import { OpeningStatus } from '../components/OpeningStatus';
import { NavActionSheet } from '../components/NavActionSheet';
import { PrimaryButton } from '../components/PrimaryButton';
import { useApp } from '../state/store';
import { usePlaceDetails } from '../hooks/usePlaceDetails';
import { formatArrivalClock, primaryType } from '../lib/format';

export function Screen4Detail() {
  const selectedPlaceId = useApp((s) => s.selectedPlaceId);
  const restaurants = useApp((s) => s.restaurants);
  const setScreen = useApp((s) => s.setScreen);
  const restaurant = restaurants.find((r) => r.placeId === selectedPlaceId) ?? null;
  const { details, isLoading } = usePlaceDetails(selectedPlaceId);
  const [navOpen, setNavOpen] = useState(false);

  if (!restaurant) {
    return (
      <div className="screen">
        <div className="content">
          <div className="sheet-empty">Ingen restaurang vald.</div>
        </div>
      </div>
    );
  }

  const typeLabel = primaryType(details?.types ?? restaurant.types);

  return (
    <div className="screen screen--detail">
      <DetailHero
        name={restaurant.name}
        typeLabel={typeLabel}
        priceLevel={restaurant.priceLevel ?? null}
        rating={restaurant.rating ?? null}
        photoRef={details?.photoRefs[0] ?? restaurant.photoRef ?? null}
        onBack={() => setScreen(3)}
      />

      <div className="detail-body">
        <div className="detail-chips">
          <DetourPill minutes={restaurant.detourMinutes} />
          <span className="meta-pill">🕓 Framme kl {formatArrivalClock(restaurant.timeToReachMinutes)}</span>
        </div>

        {details && (
          <OpeningStatus
            periods={details.openingPeriods ?? []}
            openNow={details.openNow}
            timeToReachMinutes={restaurant.timeToReachMinutes}
          />
        )}

        {details && details.reviews.length > 0 && (
          <section className="detail-section">
            <span className="detail-label">Recensioner</span>
            {details.reviews.map((rev, i) => (
              <div key={i} className="review-card">
                <div className="review-head">
                  <span className="review-author">{rev.authorName}</span>
                  {rev.rating != null && <span className="review-rating">★ {rev.rating}</span>}
                </div>
                <p className="review-text">{rev.text}</p>
              </div>
            ))}
          </section>
        )}

        {isLoading && <div className="sheet-empty">Hämtar detaljer…</div>}
      </div>

      <div className="detail-cta">
        <PrimaryButton onClick={() => setNavOpen(true)}>Navigera hit</PrimaryButton>
      </div>

      {restaurant.location && (
        <NavActionSheet
          location={restaurant.location}
          open={navOpen}
          onClose={() => setNavOpen(false)}
        />
      )}
    </div>
  );
}
